














import { defineComponent } from '@vue/composition-api';
import { Routes } from '@front-app/constants/routes';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import DeclineInvitation from '@front-app/components/DeclineInvitation.vue';
import { EventRoleRequest, updateEventMemberRole } from '@front-app/services/EventsApi/EventsMemberApi';
import { EventsStore } from '@front-app/store/singletons/Events';

export default defineComponent({
	components: {
		DeclineInvitation,
	},
	props: {
		eventId: {
			type: String,
			required: true,
		},
		groupId: {
			type: String,
			default: '',
		},
	},
	setup(props, ctx) {
		const {
			status,
			track,
			clear,
		} = useAsyncStatus();
		const confirmInvitationDecline = async () => {
			await track(updateEventMemberRole(props.eventId, EventRoleRequest.DECLINE)
				.then(() => EventsStore.getInstance().getEvents()));
			if (props.groupId) {
				ctx.root.$router.push({ name: Routes.GROUP_EVENTS });
			} else {
				ctx.root.$router.push({ name: Routes.EVENTS });
			}
		};
		return {
			status,
			clear,
			confirmInvitationDecline,
		};
	},
});
